import { gql } from '@apollo/client';

export const UPDATE_ORGANISATION_REPORT_COLORS = gql`
  mutation updateOrganisationReportColors(
    $organisationId: ID!
    $reportColors: ReportColorsInput!
  ) {
    updateOrganisationReportColors(
      organisationId: $organisationId
      reportColors: $reportColors
    ) {
      id
      reportColors {
        red
        amber
        green
      }
    }
  }
`;

export const UPDATE_FEDERATION_REPORT_COLORS = gql`
  mutation updateFederationReportColors(
    $federationId: ID!
    $reportColors: ReportColorsInput!
  ) {
    updateFederationReportColors(
      federationId: $federationId
      reportColors: $reportColors
    ) {
      id
      reportColors {
        red
        amber
        green
      }
    }
  }
`;
